import { useEffect } from 'react';
import './pdfViewerModal.scss';
import { pdfViewerModalProps } from './types/pdfViewerModalProps';


const PdfViewerModal = (props: pdfViewerModalProps) => {

    useEffect(() => {

    }, [props.pdfData]);
    return (
        <>
            <iframe title='pdf' src={URL.createObjectURL(props.pdfData)} width="99%" height="99%" />
        </>
    )
}

export default PdfViewerModal;